import { LoadingIndicator } from "@/shared/components/LoadingIndicator";
import { lazyLoad } from "@/shared/utils/loadable";

/**
 * The route is mounted with `heroBleed` + `headerTone="light"`, so the header
 * is white type with no background. The chunk fallback therefore lays down the
 * header's own height in ink first — otherwise the nav is white-on-white for
 * as long as the chunk takes to arrive.
 */
const Fallback = () => (
  <>
    <div aria-hidden className="h-[var(--kf-header-h)] w-full bg-kf-ink" />
    <LoadingIndicator fullPageHeight />
  </>
);

export const LandingPage = lazyLoad(
  () => import("./index"),
  (module) => module.default,
  { fallback: <Fallback /> }
);
